import React from "react";
import { HelpCircle } from "lucide-react";
import lucideIcons from "./lucideIcons";

/**
 * <Icon name="Heart" /> — wrapper sobre o lucide-react.
 *
 * Usa um mapa gerado (lucideIcons.js) em vez de `import * as lucide`, que
 * arrastava a biblioteca inteira (~800 kB) para o chunk inicial. Ao usar um
 * ícone novo, rode `npm run icons:generate`; nomes desconhecidos continuam
 * caindo no fallback abaixo.
 */
function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) {
  const IconComponent = lucideIcons[name];

  if (!IconComponent) {
    return (
      <HelpCircle
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}

export default React.memo(Icon);
